<template>
  <v-container grid-list-sm fluid>
    <v-layout>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <v-card-title>
            <v-layout row wrap>
              <v-flex>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon @click="ejecutarAccion('Cerrar')" v-on="on">
                      <v-icon>arrow_back</v-icon>
                    </v-btn>
                  </template>
                  <span>Volver</span>
                </v-tooltip>
              </v-flex>
              <v-flex>
                <v-text-field
                  ref="controlFoco"
                  label="¿Texto a buscar?"
                  v-model="textoBuscado"
                  @keyup.enter="ejecutarAccion('Listar')"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="primary"
                      @click="ejecutarAccion('Listar')"
                      v-on="on"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                  </template>
                  <span>Buscar</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="columnas"
              :items="itemsDB"
              :loading="loading"
              loading-text="Cargando..."
              :items-per-page="10"
              :footer-props="{
                itemsPerPageText: 'Mostrar'
              }"
              dense
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td v-for="columna in columnas" :key="columna.value">
                    <template v-if="columna.mask == undefined">{{
                      item[columna.value]
                    }}</template>
                    <template v-else>
                      <template v-if="columna.mask == 'esFecha'">{{
                        item[columna.value] | esFecha
                      }}</template>
                      <template v-else>
                        <template v-if="columna.mask == 'esMoneda'">{{
                          item[columna.value] | esMoneda
                        }}</template>
                      </template>
                    </template>
                  </td>
                </tr>
              </template>
              <template v-slot:no-data
                >-</template
              >
              <template v-slot:[`footer.page-text`]="items">
                {{ items.pageStart }} de {{ items.itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import Mensaje from "@/components/Mensaje";
export default {
  name: "ArticuloConsultaPrecio",
  components: {
    Mensaje
  },
  data() {
    return {
      titulo: "Consulta de Precios",
      columnas: [
        { text: "Nombre", value: "Nombre" },
        { text: "Actualizado", value: "FechaCambioPrecio", mask: "esFecha" },
        { text: "Contado", value: "Contado", mask: "esMoneda" }
      ],
      textoBuscado: "",
      itemsDB: [],
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  mounted() {
    this.ejecutarAccion("Inicializar");
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Listar":
          this.listarItems(this.textoBuscado);
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          setTimeout(() => {
            this.$refs.controlFoco.focus();
          }, 500);
          break;
        case "Cerrar":
          this.$router.go(-1);
          break;
      }
    },
    listarItems(textoBuscado) {
      this.loading = true;
      this.itemsDB = [];
      HttpHelper.get("Articulo", {
        palabra: textoBuscado
      })
        .then(response => {
          this.itemsDB = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
